import dealersSlice from 'modules/dealers/reducer';

const actions = { ...dealersSlice.actions };

export default actions;
